import { defineStore } from 'pinia'

import { getPendingCount } from '@/api/call-tracking/dispute/dispute-routes'

import { useDefaultStore } from '@/store/defaultStore'
import { usePermissionsStore } from '@/store/permissionsStore'

export const useDisputeCounterStore = defineStore('disputeCounterStore', {
    state: () => ({
        pendingCounter: 0,
    }),

    actions: {
        async goToLoadDisputePendingCount() {
            const permissionsStore = usePermissionsStore()

            if (!permissionsStore.permissions.disputes.view) {
                return
            }

            const { success, payload, message } = await getPendingCount()

            if (success) {
                this.pendingCounter = payload
            } else {
                const defaultStore = useDefaultStore()
                defaultStore.setErrorMessage({ message })
            }
        },
    },
})
